import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Icon from "../../components/Icon";
import RoomCarousel from "../../components/RoomCarousel";
import DateCarousel from "../../components/DateCarousel";
import MonthCarousel from "../../components/MonthCarousel"; // <-- importe aqui
import CardHorarios from "../../components/CardHorarios";
import { getSalas } from "../../services/salas";
import { formatHorario } from "../../utils/timeUtils";
import { getMonthName } from "../../utils/dateUtils";
import "./styles.css";

const PaginaInicialMobile = () => {
  const navigate = useNavigate();
  const { roomId } = useParams();

  const [selectedRoom, setSelectedRoom] = useState(null);
  const [selectedSchedule, setSelectedSchedule] = useState(null);
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedMonth, setSelectedMonth] = useState(new Date().getMonth());

  useEffect(() => {
    const fetchSala = async () => {
      try {
        const salas = await getSalas();
        const room = salas.find((sala) => sala._id === roomId);
        setSelectedRoom(room);
      } catch (error) {
        console.error("Erro ao buscar sala:", error);
      }
    };
    fetchSala();
  }, [roomId]);

  const onClickSchedule = (roomName, schedule) => {
    setSelectedSchedule({ roomName, schedule });
  };

  const handleAgendar = () => {
    if (!selectedRoom || !selectedSchedule) return;
    navigate("/agendamento", {
      state: {
        roomId: selectedRoom._id,
        roomName: selectedRoom.nome,
        scheduleId: selectedSchedule.schedule._id,
        scheduleTime: selectedSchedule.schedule.horario,
      },
    });
  };

  // Caso ainda não tenha carregado a sala
  if (!selectedRoom) {
    return <div>Carregando...</div>;
  }

  // Função opcional para resetar a data ao trocar de mês
  const handleSelectMonth = (monthIndex) => {
    setSelectedMonth(monthIndex);
    setSelectedDate(null); // Se quiser "desmarcar" o dia quando trocar de mês
  };

  return (
    <div className="room-details">
      <div className="back-container">
        <button className="back-button" onClick={() => navigate(-1)}>
          <Icon name="chevronLeft" size={30} className="icon" />
        </button>
        <span className="selected-room-name">{selectedRoom.nome}</span>
      </div>

      <div className="content">
        <RoomCarousel 
          onSelectRoom={setSelectedRoom} 
          selectedRoom={selectedRoom} 
        />

        {/* Exibe o mês por extenso se quiser */}
        <p>{selectedDate ? getMonthName(selectedDate) : ""}</p>

        {/* Carrossel de Meses */}
        <MonthCarousel onSelectMonth={handleSelectMonth} />

        {/* Carrossel de Datas */}
        <DateCarousel
          qntdItems={4}
          onSelectDate={setSelectedDate}
          selectedMonth={selectedMonth}
        />

        <CardHorarios
          roomId={selectedRoom._id}
          roomName={selectedRoom.nome}
          selectedDate={selectedDate}
          onClickSchedule={onClickSchedule}
        />
      </div>

      <div className="footer">
        {selectedSchedule ? (
          <div className="footer-selected">
            <p>
              {formatHorario(selectedSchedule.schedule.horario, selectedSchedule.roomName)}
              <br />
              {selectedSchedule.roomName}
            </p>
            <button onClick={handleAgendar}>
              Agendar
              <Icon name="chevronRight" size={20} className="icon" />
            </button>
          </div>
        ) : (
          <p>Selecione o horário desejado</p>
        )}
      </div>
    </div>
  );
};

export default PaginaInicialMobile;
